import styled from '@emotion/styled';
import { Flex } from 'antd';

export const Toolbar = styled(Flex)`
  width: 100%;
`;

export const ColumnTitle = styled.span`
  font-size: 12px;
  line-height: 19px;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const MemberCell = styled(Flex)`
  min-width: 220px;
`;

export const Avatar = styled(Flex)`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.blueLight};
  color: ${({ theme }) => theme.colors.link};
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const Name = styled.span`
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
`;

export const Email = styled.span`
  font-size: 12px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const CompanyLink = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.link};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const DrawerRow = styled(Flex)`
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSecondary};
`;

export const DrawerRowTitle = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;
